function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

jQuery(document).ready(function ($) {

    // Apply style to a if touch device
    if (isTouchDevice()) {
        $('a, button, input').addClass('touch-device');
        $('a, button, input').removeClass('click-device');
    }
    else {
        $('a, button, input').addClass('click-device');
        $('a, button, input').removeClass('touch-device');
    }

});
//# sourceMappingURL=device-recognition.js.map
